import { FC, ReactNode, useEffect, useState } from 'react';
import { Tooltip } from '@chakra-ui/react';
import styles from './AllFiltersDrawer.module.css';
interface QFTProps {
  children: ReactNode;
  content: string | null;
}

/* Chakra Tooltip is a little wonky, particularly with suppressing the tooltip
   when utilizing openDelay and the triggering component has already been interacted with.
   If we don't use openDelay, the tooltip can become a bit obtrusive when it insists on opening
   immediately. But if we do use openDelay and quickly interact with the triggering component,
   the tooltip opening does not get properly cancelled and will open up "underneath" a select
   dropdown, for example.  As a workaround, this enables a "cooling off" period for the tooltip:
   Once a particular tooltip instance has been displayed twice, it will be disabled for 30 seconds.
   Minutaie: The way this is written, the first tooltip display in sequence can remain open indefinitely,
   while the second iteration will close within 2.5 seconds
*/

export const QuickFilterTooltip: FC<QFTProps> = ({
  children,
  content
}) => {
  const [timesOpened, setTimesOpened] = useState<number>(0);
  const [disabled, setDisabled] = useState<boolean>(false);
  useEffect(() => {
    if (disabled || timesOpened < 2) return;
    const timer = setTimeout(() => setDisabled(true), 2500);
    return () => clearTimeout(timer);
  }, [timesOpened]);
  useEffect(() => {
    if (!disabled) return;
    const reenableTooltipTimer = setTimeout(() => {
      setDisabled(false);
      setTimesOpened(0);
    }, 30_000);
    return () => clearTimeout(reenableTooltipTimer);
  }, [disabled]);
  const onOpen = () => setTimesOpened(val => val + 1);
  return <Tooltip className={styles.tooltipContent} isDisabled={disabled} label={content} onOpen={onOpen} placement="bottom-start" data-sentry-element="Tooltip" data-sentry-component="QuickFilterTooltip" data-sentry-source-file="QuickFilterTooltip.tsx">
      {children}
    </Tooltip>;
};